import { Injectable } from '@angular/core';
import { EventDelegatorService } from '@services/event-delegator.service';
import { MatDialog } from '@angular/material/dialog';
import { KnowledgeBaseDialogComponent } from '@dialogs/knowledge-base-dialog/knowledge-base-dialog.component';

@Injectable()
export class FAQService {
  constructor(
    public eventDelegatorService: EventDelegatorService,
    public dialog: MatDialog
  ) {
  }

  /**
   *@param [link]
   * opens link to Knowledge Base page.
   */
  openKnowledgeBaseURL(link?: string) {
    /* fallback to Introduction Page */
    const url = 'https://support.makersite.io/support-center';
    this.dialog.open(KnowledgeBaseDialogComponent, {
      data: {
        path: '/api/v1/sso-gateway/knowledge-base/token',
        body: { url: link || url }
      },
      disableClose: true,
      panelClass: 'unauthorized-error-dialog'
    });
  }
}
